export enum ErrorCode {
  //#region Request/fetch related
  RequestFailedToFetch = 1001,
  RequestServerError = 1002,
  ResponseParsingError = 1003,
  //#endregion

  //#region App start
  AuthFailed = 1101,
  AssetAbsoluteUrlCreationFailed = 1102,
  MissingEntryScriptSource = 1103,
  //#endregion

  //#region React rendering errors
  ReactBoundaryEmbedRoot = 1201,
  //#endregion

  //#region Module Events
  ModuleEventListenerError = 1301,
  ModuleEventDispatchError = 1302,
  //#endregion

  //#region Shared component
  ExternalScriptLoadFailed = 1401,
  PaginationPageLoadFailed = 1402,
  ContactFormGeneralError = 1403,
  DateFnsLocaleLoadFailed = 1404,
  CommonBundlesLoadFailed = 1405,
  //#endregion

  //#region Labels
  LabelFetchFailed = 1501,
  LabelParseError = 1502,
  LabelBadRequest = 1503,
  //#endregion

  //#region CSW
  CswFilterFetchFailed = 2001,
  CswGaEventFailed = 2002,
  //#endregion

  //#region FinanceCalculator 201x
  FcProductFetchFailed = 2011,
  FcQuoteFetchFailed = 2012,
  FcRequestForFinanceFailed = 2013,
  FcNoVehicleIdProvided = 2014,
  FcContactFormSettingFetchFailed = 2015,
  //#endregion

  //#region Location
  LocationMapsConfigurationError = 2021,
  LocationAdvisorFetchFailed = 2022,
  LocationDetailsFetchFailed = 2023,
  LocationListFetchFailed = 2024,
  LocationContactFormConfigFetchFailed = 2025,
  LocationGeneralHoursFetchFailed = 2026,
  LocationMemberFetchFailed = 2027,
  //#endregion

  //#region Showroom
  ShowroomModelListFetchFailed = 2031,
  ShowroomCompactModelListFetchFailed = 2032,
  ShowroomModelDataFetchFailed = 2033,
  ShowroomComplexModelDataFetchFailed = 2034,
  ShowroomCategoryListFetchFailed = 2035,
  ShowroomListBannerSaveOrUpdateFailed = 2036,
  ShowroomListBannerFetchFailed = 2037,
  //#endregion

  //#region VACS
  VacsSettingFetchFailed = 2041,
  VacsFilterFetchFailed = 2042,
  VacsContactFormConfigFetchFailed = 2043,
  VacsDealerLocatonsFetchFailed = 2044,
  VacsAdvancedSettingsListFetchFailed = 2045,
  VacsAdvancedSettingsFetchFailed = 2046,
  VacsAdvancedSettingSaveFailed = 2047,
  VacsAdvancedSettingUpdateFailed = 2047,
  VacsAdvancedSettingDeleteFailed = 2048,
  VacsAdvancedSettingGetSnippetFailed = 2049,
  VacsAdvancedSettingUploadImageFailed = 2050,
  //#endregion

  //#region Advisor
  AdvisorReviewFetchFailed = 2051,
  AdvisorRecommendationFetchFailed = 2052,
  //#endregion

  //#region Article
  ArticleFetchFailed = 2061,
  //#endregion

  //#region Catwalk
  CatwalkOfferFetchFailed = 2071,
  //#endregion

  //#region OfferWidget
  OfferWidgetOfferFetchFailed = 2081,
  //#endregion

  //#region TLP
  TlpLandingPageFetchFailed = 2091,
  TlpSalesOfferFetchFailed = 2092,
  TlpStockFetchFailed = 2093,
  TlpStockDetailsFetchFailed = 2094,
  TlpDealerLocationFetchFailed = 2094,
  //#endregion

  //#region WelcomeText
  WelcomeTextFetchFailed = 2101,
  //#endregion

  //#region WelcomeText
  DealerIntroductionFetchFailed = 2102,
  //#endregion

  //#region WelcomeText
  LinkBoxFetchFailed = 2069,
  //#region TeamsWidgetFailed
  TeamsWidgetFailed = 2070,
  //#region GalleryWidget
  GalleryWidgetFailed = 2071,

  //#region DownloadsWidget
  DownloadsWidgetFailed = 2072,

  //#region SimpleOfferFetchFailed
  SimpleOfferFetchFailed = 2073,
  //#endregion

  //#region GroupedCatwalkWidget
  GroupedCatwalkWidgetFetchFailed = 2111,
  //#endregion

  //#region AfterSalesWidget
  AfterSalesWidgetFetchFailed = 2121,
  //#endregion

  //#region LandingPageWidget
  LandingPageWidget = 42069,
  //#endregion

  //#region Server
  TelemetryFails = 3000,
  TelemetryUnrecognizedFormat = 3001,
  LogUnrecognizedFormat = 3002,
  //#endregion

  //#region VacsAdminList
  VacsAdminCarListFetchFailed = 3030,
  VacsAdminCarListDeleteFailed = 3031,
  VacsAdminCarDetailsFailed = 3032,
  VacsAdminCarListCreateFailed = 3033,
  VacsAdminCarListDuplicateFailed = 3034,
  VacsAdminCarDefaultImageFailed = 3035,
  VacsAdminCarListCountFailed = 3036,
  VacsAdminCarUploadImage = 3037,
  VacsAdminCarDeleteImage = 3038,
  VacsAdminCarListUpdateFailed = 3039,
  VacsAdminCarOptionsListFailed = 3040,
  VacsAdminManualVehicleEnabledFailed = 3041,
  VacsAdminManualVehicleExportAllFailed = 3042,
  VacsAdminManualVehicleUploadFailed = 3043,
  VacsAdminManualVehicleHistoryFailed = 3044,
  VacsAdminManualVehicleHistoryDetailsFailed = 3045,
  VacsAdminPriceUploadExportFailed = 3046,
  VacsAdminPriceUploadExportAllFailed = 3047,
  VacsAdminPriceUploadFailed = 3048,
  VacsAdminPriceSettingsFailed = 3049,
  VacsAdminDictionaryExportFailed = 3050,
  VacsAdminDictionaryImportFailed = 3051,
  //#endregion

  //#region VehicleDesigner
  VehicleDesignerCarsFetchFailed = 3501,
  //#endregion

  //#region AutoVista
  VacsAdminCarDetailsByAutoVistaVin = 3502,
  //#endregion
  CommonFormWidgetFetchFailed = 3003,
  StandardProWidgetFetchFailed = 3004,
  StandardProWidgetSaveFailed = 3005,
  StandardProWidgetUpdateFailed = 3006,
  StandardProShowroomBannerWidgetUpdateOrSaveFailed = 3007,
  LeasingAndUsedCarsFetchFailed = 4000,

  //#region Stripe
  StripePaymentError = 4001,
  //#endregion

  //#region Reservation
  ReservationError = 4002,
  //#endregion

  //#region Footer
  FooterError = 4003,
  //#endregion

  //#region Banner
  BannerError = 4004,
  //#endregion

  //#region SPW (Standard Pro Widget)
  StandardProSidebarFormGetFailed = 5001,
  StandardProSidebarFormListTypesGetFailed = 5002,
  //#endregion

  //#region PublishingOptions
  InvalidRegexPattern = 7000,
  //#endregion
}
